import { store } from '~/plugins/vuex';

import { ORG_ROLES, ORG_TYPES, USER_ROLE_GROUPS } from '../constants';

function getOrgContentModeLabel(org, t) {
  const orgType = org.type === ORG_TYPES.partner ? ORG_TYPES.consumer : org.type;
  const user = store.state.auth.user;
  const userType = user.roles.some((role) => ORG_ROLES.includes(role))
    ? USER_ROLE_GROUPS.client
    : USER_ROLE_GROUPS.cruxer;

  return t(`labels.orgContentMode.${orgType}.${userType}`, { org: org.name });
}

export function useOrg() {
  return {
    getOrgContentModeLabel,
  };
}
